import React from 'react';
import SignaturePad from 'signature_pad';
import debounce from 'utils/debounce';

type Props = {
  value: string | null;
  onChange: (value: string | null) => void;
};

export class Signature extends React.PureComponent<Props, any> {
  canvasRef: React.RefObject<HTMLCanvasElement>;
  pad?: SignaturePad;

  constructor(props: Props) {
    super(props);

    this.fromDataURL = this.fromDataURL.bind(this);
    this.resizeCanvas = debounce(this.resizeCanvas.bind(this));
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    this.pad = new SignaturePad(this.canvasRef.current!, {
      minWidth: 3,
      maxWidth: 5,
      velocityFilterWeight: 0.5,
      penColor: '#284283',
      backgroundColor: 'transparent',
    });

    this.pad.addEventListener('endStroke', () => {
      if (this.props.onChange && this.pad) {
        const data = this.pad.toDataURL();
        return this.props.onChange.call(this, data);
      }
    });

    window.addEventListener('resize', this.resizeCanvas);
    this.resizeCanvas();
  }

  componentDidUpdate() {
    if (this.props.value && this.pad) {
      this.pad.fromDataURL(this.props.value);
    }
  }

  componentWillUnmount() {
    if (!this.pad) return;
    this.pad.off();
    window.removeEventListener('resize', this.resizeCanvas);
  }

  resizeCanvas() {
    const canvas = this.canvasRef.current;
    if (!this.pad || !canvas) return;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d')?.scale(ratio, ratio);

    this.pad.clear();
    if (this.props.value) {
      this.pad.fromDataURL(this.props.value);
    }
  }

  fromDataURL(params: string) {
    if (!this.pad) return;
    return this.pad.fromDataURL(params);
  }

  resetValue: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    if (!this.canvasRef.current) return;

    event.currentTarget.blur();
    this.props.onChange.call(this, null);
    const canvas = this.canvasRef.current;
    const {width, height} = canvas;
    canvas.getContext('2d')?.clearRect(0, 0, width, height);
  };

  render() {
    return (
      <div className="h-100 d-flex align-items-start">
        <canvas className="form-control h-100 flex-grow-1" ref={this.canvasRef} style={{width: '90%'}} />
        <button
          type="button"
          className="close ml-2"
          aria-label="Reset"
          style={{width: '30px', fontSize: '2.5rem'}}
          onClick={this.resetValue}>
          <span>&times;</span>
        </button>
      </div>
    );
  }
}
